import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
} from 'react';

import { AuthContext } from '@mint-lib/auth';
import { useService as useOldService } from '@mint-lib/hooks';

import { UserProfile } from '../getUserProfile/index.js';
import { ProfileService } from '../services/ProfileService.js';

export type AmbiguousUserProfile = null | UserProfile;

export type ProfileContextValue<IsAmbiguous extends boolean> = {
  profileData: IsAmbiguous extends true ? AmbiguousUserProfile : UserProfile;
  setProfileData: Dispatch<SetStateAction<AmbiguousUserProfile>>;
  profileService: ProfileService;
};

// @ts-ignore
export const ProfileContext = createContext<ProfileContextValue>();

/**
 * @deprecated
 */
export const ProfileProvider = ({
  children,
  value = null,
}: {
  children: ReactNode;
  value?: AmbiguousUserProfile;
}) => {
  const auth = useContext(AuthContext);
  const [profileService] = useOldService(ProfileService, auth);

  useEffect(() => {
    console.warn(
      'ProfileProvider from @mint-lib/profile-helpers has been deprecated, please use the new ProfileProvider from @mint-lib/routing-context instead.',
    );
  }, []);

  return (
    <ProfileContext.Provider
      value={{
        profileData: profileService.getProfileData(),
        setProfileData: profileService.setProfileData.bind(profileService),
        profileService,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
